import { render, staticRenderFns } from "./DocumentOrderModal.vue?vue&type=template&id=dc6d111c"
import script from "./DocumentOrderModal.vue?vue&type=script&lang=js"
export * from "./DocumentOrderModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentOrderModal.vue?vue&type=style&index=0&id=dc6d111c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports